import { useMemo } from 'react';
import { canAccess } from '../utils/platformPermissions';

// May the signed-in person perform the WRITE side of a page?
//
// A page opens on its `.view` key (App.jsx / config/platformNav.js) and the
// API refuses its create / edit / delete / toggle calls without the matching
// `.manage` key. Pages hide those controls behind this hook so a view-only
// platform staff member is not offered a row of buttons that all return 403.
// Super Admin always passes; anyone who is neither Super Admin nor a platform
// staff member holding the key fails closed.
//
// SECURITY: presentation only — the backend re-resolves the permission live
// on every call (api/middleware/requirePlatformPermission.js).
//
// Snapshot, not a subscription: permissions are written at login and wiped at
// logout, both of which navigate, so the value cannot go stale mid-page.
const useCanManage = (perm) => useMemo(() => canAccess(perm), [perm]);

export default useCanManage;
